const memory = new Map<string, string>();

/**
 * Memory Storage that mimics localStorage but just uses memory
 */
export const memoryStorage: Storage = {
  clear() {
    memory.clear();
  },
  getItem(key) {
    return memory.get(key) ?? null;
  },
  removeItem(key) {
    memory.delete(key);
  },
  setItem(key, value) {
    memory.set(key, value);
  },

  // Unnecessary props
  key() {
    return null;
  },
  length: 0
};
